import { Alert, FormControl, FormHelperText, IconButton, InputAdornment, InputLabel, OutlinedInput, TextField } from "@mui/material";

import { SearchRounded, Visibility, VisibilityOff } from "@mui/icons-material";
import ButtonBack from "../../components/global/ButtonBack";
import PrimaryButton from "../../components/global/PrimaryButton";
import { useNavigate } from "react-router";
import { useEffect, useState } from "react";
import TopBar from "../../components/global/TopBar";
import ProgressBar from "../../components/global/ProgressBar";
import { authAPI } from "../../api";
import DynamicIcon from "../../components/global/DynamicIcon";
import CircularLoading from "../../components/global/CircularLoading";
import Input from "../../components/global/Input";
import { ConfigureLoginForm, Empresa } from "../../types/global/UserAuthTypes";
import AlertErro from "../../components/global/AlertErro";

function ConfigureLogin() {
  let navigate = useNavigate()
  const [step, setStep] = useState(1)
  const [empresas, setEmpresas] = useState<Empresa[]>([])
  const [empresasFiltradas, setEmpresasFiltradas] = useState<Empresa[]>([])
  const [erroEmpresas, setErroEmpresas] = useState(false)
  const [erroEmpresaMessage, setErroEmpresaMessage] = useState("")
  const [loading, setLoading] = useState(true)
  const [search, setSearch] = useState("")
  const [erroAuth, setErroAuth] = useState(false)
  const [showPassword, setShowPassword] = useState(false)
  const [erroLogin, setErroLogin] = useState(false)
  const [erroPassword, setErroPassword] = useState(false)
  const [erroAuthMessage, setErroAuthMessage] = useState("")
  const [userExisting, setUserExisting] = useState(false)
  const [loadingInput, setLoadingInput] = useState(false)
  const [loginAvailable, setLoginAvailable] = useState(false)
  const [loginNotAvailable, setLoginNotAvailable] = useState(false)
  const [erroConfigure, setErroConfigure] = useState(false)
  const [erroConfigureMessage, setErroConfigureMessage] = useState("")

  const [form, setForm] = useState<ConfigureLoginForm>({
    empresaId: 0,
    login: "",
    password: "",
    newLogin: null
  })

  useEffect(() => {
    setStep(1)
    getEmpresas()
  }, [])

  const handleNewLogin = async (value: string) => {
    setLoadingInput(true)
    const result = await authAPI.loginAvailable({ login: value, empresaId: form.empresaId, WithLoginInterno: true })
    if (result.statusCode == 400) {
      setLoginAvailable(false)
      setLoginNotAvailable(true)
    }
    else if (result.statusCode == 200) {
      setLoginAvailable(true)
      setLoginNotAvailable(false)
    }
    else {
      setLoginAvailable(false)
      setLoginNotAvailable(false)
    }
    setLoadingInput(false)
  }

  const handleClickShowPassword = () => setShowPassword((show: boolean) => !show)

  const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault()
  }

  const handleMouseUpPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault()
  }

  const validateFields = (): boolean => {
    if (form.login == null || form.login == "") {
      setErroLogin(true)
      return false
    }
    if (form.password == null || form.password == "") {
      setErroPassword(true)
      return false
    }
    if (form.empresaId == null || form.empresaId == 0) {
      setStep(1)
      return false
    }
    return true
  }

  const configureLogin = async () => {
    setLoading(true)
    var result = await authAPI.configureLogin(form)
    if (result.statusCode == 200) {
      setUserExisting(false)
      setStep(4)
    }
    else if (result.statusCode == 400) {
      setUserExisting(false)
      setStep(3)
    }
    else if (result.statusCode == 401) {
      setErroAuth(true)
      setErroAuthMessage(result.error?.Message ?? "Ocorreu um erro inesperado.")
    }
    else if (result.statusCode == 405) {
      setUserExisting(true)
      setStep(4)
    }
    else {
      setErroConfigure(true)
      setErroConfigureMessage(result.error?.Message ?? "Ocorreu um erro inesperado.")
    }
    setLoading(false)
  }

  const getEmpresas = async () => {
    setLoading(true)
    const empresas = await authAPI.getEmpresas()
    if (empresas.data && empresas.statusCode == 200) {
      setEmpresas(empresas.data)
    }
    else {
      setErroEmpresas(true)
      setErroEmpresaMessage(empresas.error?.Message ?? "Ocorreu um erro inesperado.")
    }
    setLoading(false)
  }

  const handleSearch = (search: string) => {
    setSearch(search)
    if (search.length > 1) {
      const filter = empresas.filter(x => x.nome.toLowerCase().includes(search.toLowerCase()))
      setEmpresasFiltradas(filter)
    }
    else {
      setEmpresasFiltradas([])
    }
  }

  return (
    <>
      <TopBar logo={false} />
      <div className="w-screen min-h-screen bg-white dark:bg-background-dark flex flex-col items-center justify-between overflow-y-scroll overflow-x-hidden">
        <div>
          <div className="w-screen h-full p-6 mt-16 max-w-[550px] lg:w-[550px]">
            <ProgressBar variant="determinate" value={step == 1 ? 25 : (step == 2 ? 50 : step == 3 ? 75 : 100)} />
            <div className="w-full mt-8">
              {
                step != 4 &&
                <ButtonBack onClick={() => {
                  setErroAuth(false)
                  setErroConfigure(false)
                  setErroEmpresas(false)

                  if (step == 3) {
                    setForm((form) => ({
                      ...form,
                      newLogin: null
                    }))
                    setLoadingInput(false)
                    setLoginAvailable(false)
                    setLoginNotAvailable(false)
                  }

                  if (step == 1) {
                    navigate("/login")
                  }
                  else setStep(step - 1)
                }} />
              }
            </div>
            {
              loading == true &&
              <div className="w-full h-72 flex justify-center items-center">
                <CircularLoading size={35} />
              </div>
            }
            {
              (step == 3 && loading == false) &&
              <>
                <div className="text-black dark:text-white w-full mt-8 flex flex-col gap-4">
                  <h1 className="text-3xl font-semibold">
                    Configurar novo login
                  </h1>
                  <p className="text-sm font-regular">
                    O login que você utilizava no sistema antigo já está em uso por outro usuário no novo sistema. Por esse motivo, será necessário escolher um novo login. Seu login no sistema antigo também será atualizado.
                  </p>
                </div>
                <div className="w-full flex gap-4 flex-col items-center justify-center mt-16">
                  <div className="w-full">
                    <h1 className="text-black dark:text-white font-semibold">Informe os dados abaixo:</h1>
                  </div>
                  <Input
                    variant="outlined"
                    label="Novo login"
                    id="outlined-size-small"
                    size="small"
                    error={loginNotAvailable}
                    helperText={loginNotAvailable ? "Este login já está em uso por outro usuário" : ""}
                    loading={loadingInput}
                    checked={loginAvailable}
                    failed={loginNotAvailable}
                    value={form.newLogin}
                    onChange={(x) => {
                      setErroConfigure(false)
                      setForm((form) => ({
                        ...form,
                        newLogin: x.target.value
                      }))
                    }}
                    onChangeDebounce={async (value) => {
                      if (value) {
                        await handleNewLogin(value)
                      }
                      else {
                        setLoadingInput(false)
                        setLoginAvailable(false)
                        setLoginNotAvailable(false)
                      }
                    }}
                  />
                  {
                    erroConfigure == true &&
                    <Alert severity="error">{erroConfigureMessage}</Alert>
                  }
                </div>
                <div className="w-full flex justify-end my-10">
                  <div className="w-44">
                    <PrimaryButton onClick={async () => {
                      if (loginAvailable) {
                        await configureLogin()
                      }
                    }}>Próximo</PrimaryButton>
                  </div>
                </div>
              </>
            }
            {
              (step == 2 && loading == false) &&
              <>
                <div className="text-black dark:text-white w-full mt-8 flex flex-col gap-4">
                  <h1 className="text-3xl font-semibold">
                    Informe o seu login do sistema antigo
                  </h1>
                  <p className="text-sm font-regular">
                    Faça login com as mesmas credenciais que você utiliza no sistema antigo.
                  </p>
                </div>
                <div className="w-full flex gap-4 flex-col items-center justify-center mt-16">
                  <div className="w-full">
                    <h1 className="text-black dark:text-white font-semibold">Informe os dados abaixo</h1>
                  </div>
                  <TextField
                    fullWidth
                    type="email"
                    helperText={erroAuth == true ? "" : (erroLogin == true ? "Digite um login válido" : "")}
                    label="Login"
                    value={form.login}
                    error={erroAuth || erroLogin}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                      setErroAuth(false)
                      setErroLogin(false)
                      setForm((form) => ({
                        ...form,
                        login: event.target.value
                      }))
                    }}
                    id="outlined-size-small"
                    size="small"
                  />
                  <FormControl sx={{ width: '100%' }} variant="outlined" size="small">
                    <InputLabel htmlFor="password-field"
                      error={erroAuth || erroPassword}
                    >Senha</InputLabel>
                    <OutlinedInput
                      id="password-field"
                      type={showPassword ? 'text' : 'password'}
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label={
                              showPassword ? 'Esconder senha' : 'Mostrar senha'
                            }
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                            onMouseUp={handleMouseUpPassword}
                            edge="end"
                          >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      }
                      value={form.password}
                      onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                        setErroAuth(false)
                        setErroPassword(false)
                        setForm((form) => ({
                          ...form,
                          password: event.target.value
                        }))
                      }}
                      error={erroAuth || erroPassword}
                      label="Senha"
                      size="small"
                      aria-describedby="component-error-text"
                      fullWidth
                    />
                    <FormHelperText id="component-error-text" error>{erroAuth == true ? "" : (erroPassword == true ? "Digite uma senha válida" : "")}</FormHelperText>
                  </FormControl>
                  {
                    erroAuth == true &&
                    <Alert severity="error">{erroAuthMessage}</Alert>
                  }
                </div>
                <div className="w-full flex justify-end my-10">
                  <div className="w-44">
                    <PrimaryButton onClick={async () => {
                      if (validateFields()) {
                        await configureLogin()
                      }
                    }}>Próximo</PrimaryButton>
                  </div>
                </div>
              </>
            }
            {
              (step == 4 && loading == false) &&
              <>
                <div className="text-black dark:text-white w-full mt-8 flex flex-col gap-4">
                  <h1 className="text-3xl font-semibold">
                    {
                      userExisting == true ? "Este login já foi configurado anteriormente." : "O seu acesso ao novo sistema foi configurado com sucesso!"
                    }
                  </h1>
                  <p className="text-sm font-regular">
                    Faça login para começar a utilizar o sistema.
                  </p>
                </div>
                <div className="w-full flex justify-end my-10">
                  <div className="w-44">
                    <PrimaryButton onClick={() => navigate("/login")}>Fazer login</PrimaryButton>
                  </div>
                </div>
              </>
            }
            {
              (step == 1 && loading == false) &&
              <>
                <div className="text-black dark:text-white w-full mt-8 flex flex-col gap-4">
                  <h1 className="text-3xl font-semibold">
                    Qual é o nome da sua empresa?
                  </h1>
                  <p className="text-sm font-regular">
                    Digite pelo menos os dois primeiros caracteres do nome da sua empresa e selecione a opção correspondente
                  </p>
                </div>
                <div className="w-full flex gap-4 flex-col items-center justify-center mt-12">
                  <FormControl sx={{ width: '100%' }} variant="outlined" size="small">
                    <InputLabel htmlFor="search-field">Pesquisar</InputLabel>
                    <OutlinedInput
                      id="search-field"
                      endAdornment={
                        <InputAdornment position="end">
                          <SearchRounded />
                        </InputAdornment>
                      }

                      label="Pesquisar"
                      size="small"
                      value={search}
                      onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                        handleSearch(event.target.value)
                      }}
                      aria-describedby="component-error-text"
                      fullWidth
                    />
                    <FormHelperText id="component-error-text">Ex: Digite "Gdol"</FormHelperText>
                  </FormControl>
                  {
                    erroEmpresas == true &&
                    <AlertErro messageErro={erroEmpresaMessage} onTryAgain={async () => await getEmpresas()} />
                  }
                  <div className="w-full">
                    {
                      empresasFiltradas.map(x => (
                        <div key={x.id} className="w-full border-b-[1px] border-b-border-light-gray dark:border-b-border-dark-gray p-3 flex justify-between items-center cursor-pointer hover:bg-hover-light-gray rounded-[4px]"
                          onClick={() => {
                            setForm((form) => ({
                              ...form,
                              empresaId: x.id
                            }))
                            setStep(2)
                          }}
                        >
                          <p className="text-black dark:text-white">{x.nome}</p>
                          <div className="flex items-center gap-2">
                            <p className="text-sm text-primary-green">Selecionar</p>
                            <DynamicIcon nameIcon="ArrowForwardRounded" className="text-primary-green" size={25} />
                          </div>
                        </div>
                      ))
                    }
                    {
                      (search.length > 2 && empresasFiltradas.length == 0) &&
                      <div className="text-black dark:text-white w-full mt-8 flex flex-col gap-4 justify-center items-center">
                        <h1 className="text-xl font-medium">
                          Nenhuma empresa encontrada...
                        </h1>
                      </div>
                    }
                  </div>
                </div>
              </>
            }
          </div>
        </div>
        <div className="w-full h-3 bg-primary-green rounded-t-sm" />
      </div>
    </>

  );
}

export default ConfigureLogin;